export default "__VITE_ASSET__Dbz9J01w__"